module.exports = __webpack_public_path__ + "img/Telegram.67b6aef.svg";